import api from './api'
import storageManager from './storageManager'

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  api,
  storageManager
}
